"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var RenderProp = _interopRequireWildcard(require("../utils/propTypes/renderProp"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _UIFlex = _interopRequireDefault(require("../layout/UIFlex"));

var _UITruncateString = _interopRequireDefault(require("../text/UITruncateString"));

var _HoverProvider = _interopRequireDefault(require("../providers/HoverProvider"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _TableSortArrows = _interopRequireDefault(require("./internal/TableSortArrows"));

var _SortTH_Content = _interopRequireDefault(require("./internal/SortTH_Content"));

var _SortTH_TH = _interopRequireDefault(require("./internal/SortTH_TH"));

var _SortTH_TruncateString = _interopRequireDefault(require("./internal/SortTH_TruncateString"));

var _TablePropTypes = require("./internal/TablePropTypes");

var UISortTH = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UISortTH, _Component);

  function UISortTH() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UISortTH);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UISortTH)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleClick = function (evt) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          onSortChange = _this$props.onSortChange,
          preferredSort = _this$props.preferredSort,
          sort = _this$props.sort;
      if (onClick) onClick(evt);
      if (evt.defaultPrevented) return;
      var newSort = null;

      if (sort === 'ascending') {
        newSort = 'descending';
      } else if (sort === 'descending') {
        newSort = 'ascending';
      } else {
        newSort = preferredSort;
      }

      onSortChange((0, _SyntheticEvent.default)(newSort));
    };

    return _this;
  }

  (0, _createClass2.default)(UISortTH, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          align = _this$props2.align,
          Arrows = _this$props2.Arrows,
          children = _this$props2.children,
          disabled = _this$props2.disabled,
          Content = _this$props2.Content,
          FlexContainer = _this$props2.FlexContainer,
          __onClick = _this$props2.onClick,
          __onSortChange = _this$props2.onSortChange,
          preferredSort = _this$props2.preferredSort,
          sort = _this$props2.sort,
          TH = _this$props2.TH,
          truncate = _this$props2.truncate,
          TruncateString = _this$props2.TruncateString,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["align", "Arrows", "children", "disabled", "Content", "FlexContainer", "onClick", "onSortChange", "preferredSort", "sort", "TH", "truncate", "TruncateString"]);
      return _react.default.createElement(_HoverProvider.default, this.props, function (hoverProviderProps) {
        var hovered = hoverProviderProps.hovered,
            hoverProviderRestProps = (0, _objectWithoutProperties2.default)(hoverProviderProps, ["hovered"]);
        var arrowsNode = disabled ? null : _react.default.createElement(Arrows, {
          hovered: hovered,
          preferredSort: preferredSort,
          sort: sort
        });
        return _react.default.createElement(TH, Object.assign({}, rest, hoverProviderRestProps, {
          disabled: disabled,
          hovered: hovered,
          onClick: _this2.handleClick,
          sort: sort
        }), _react.default.createElement(FlexContainer, null, _react.default.createElement(Content, {
          align: align,
          arrowsNode: arrowsNode
        }, truncate ? _react.default.createElement(TruncateString, {
          matchContentWidth: true
        }, children) : children)));
      });
    }
  }]);
  return UISortTH;
}(_react.Component);

UISortTH.propTypes = {
  align: _TablePropTypes.alignPropType.isRequired,
  Arrows: RenderProp.getPropType(_TableSortArrows.default),
  Content: RenderProp.getPropType(_SortTH_Content.default),
  FlexContainer: RenderProp.getPropType(_UIFlex.default),
  children: _propTypes.default.node,
  disabled: _propTypes.default.bool.isRequired,
  onClick: _propTypes.default.func,
  onSortChange: _propTypes.default.func.isRequired,
  preferredSort: _TablePropTypes.preferredSortPropType.isRequired,
  sort: _TablePropTypes.sortPropType.isRequired,
  TH: _propTypes.default.elementType.isRequired,
  truncate: _propTypes.default.bool.isRequired,
  TruncateString: RenderProp.getPropType(_UITruncateString.default)
};
UISortTH.defaultProps = {
  align: 'left',
  Arrows: _TableSortArrows.default,
  Content: _SortTH_Content.default,
  disabled: false,
  FlexContainer: _UIFlex.default,
  preferredSort: 'descending',
  sort: 'none',
  TH: _SortTH_TH.default,
  truncate: false,
  TruncateString: _SortTH_TruncateString.default
};
UISortTH.displayName = 'UISortTH';

var _default = (0, _Controllable.default)(UISortTH, ['sort']);

exports.default = _default;
module.exports = exports.default;